module.exports = __webpack_public_path__ + "img/name.c6450537.svg";